import * as Icons from "~/hec/assets/icons";

import type { IconComponentMap } from "./base";

/**
 * Map of icon name strings (as used in Builder) to SVG components.
 * Keys match the enum values in the Builder definition (ICON_NAMES in
 * ./inputs.ts — pinned by tests/unit/hec/builder/chrome-registry.test.ts).
 *
 * This map references every icon module, so anything that imports it welds
 * the whole icon set (~113 modules) into its chunk. It is reachable only
 * from the FULL page registry (~/hec/builder/index.ts), which is
 * route-chunked; the always-loaded chrome registry uses the audited subset
 * in ./chrome-icon-map.ts instead (COM-188).
 */
export const iconMap: IconComponentMap = {
  Svg401KMaximizer: Icons.Svg401KMaximizer,
  AcSearchArticleBgBorder: Icons.AcSearchArticleBgBorder,
  Amex: Icons.Amex,
  ArrowDown: Icons.ArrowDown,
  Arrow: Icons.Arrow,
  Bbb: Icons.Bbb,
  BrandLogo: Icons.BrandLogo,
  Calculator: Icons.Calculator,
  Call: Icons.Call,
  Chat: Icons.Chat,
  LiveChat: Icons.LiveChat,
  CheckBoxSelected: Icons.CheckBoxSelected,
  Checkmark: Icons.Checkmark,
  CircleCheckSolid: Icons.CircleCheckSolid,
  CircleFacebookIcon: Icons.CircleFacebookIcon,
  Clipboard: Icons.Clipboard,
  ClockLight: Icons.ClockLight,
  CloseBlack: Icons.CloseBlack,
  CloseThin: Icons.CloseThin,
  CloseWhite: Icons.CloseWhite,
  Close: Icons.Close,
  CollapseCaretDown: Icons.CollapseCaretDown,
  Contact: Icons.Contact,
  Dental: Icons.Dental,
  Discover: Icons.Discover,
  Download: Icons.Download,
  DrawerCloseIcon: Icons.DrawerCloseIcon,
  DropdownArrow: Icons.DropdownArrow,
  EligibilityList: Icons.EligibilityList,
  EligibleProducts: Icons.EligibleProducts,
  ElistFilterIcon: Icons.ElistFilterIcon,
  Expand: Icons.Expand,
  ExpenseWalletIcon: Icons.ExpenseWalletIcon,
  EyeCare: Icons.EyeCare,
  Facebook: Icons.Facebook,
  Faq: Icons.Faq,
  FilterClose: Icons.FilterClose,
  Flag: Icons.Flag,
  FsaCalculator: Icons.FsaCalculator,
  FsaTracker: Icons.FsaTracker,
  GlobalToolTip: Icons.GlobalToolTip,
  Google: Icons.Google,
  HelpContact: Icons.HelpContact,
  HintIcon: Icons.HintIcon,
  Hint: Icons.Hint,
  Hitrust: Icons.Hitrust,
  HsaPerksDashboard: Icons.HsaPerksDashboard,
  Heart: Icons.Heart,
  IconCheckmark: Icons.IconCheckmark,
  IconClose: Icons.IconClose,
  IconLoyalty3StepEarn: Icons.IconLoyalty3StepEarn,
  IconLoyalty3StepRedeem: Icons.IconLoyalty3StepRedeem,
  IconLoyalty3StepShop: Icons.IconLoyalty3StepShop,
  Info: Icons.Info,
  Information: Icons.Information,
  Instagram: Icons.Instagram,
  LearningCenter: Icons.LearningCenter,
  Lightbulb: Icons.Lightbulb,
  LinkedIn: Icons.LinkedIn,
  Lock: Icons.Lock,
  LogoFsaPerksNavy: Icons.LogoFsaPerksNavy,
  LogoHsaPerksNavy: Icons.LogoHsaPerksNavy,
  Mail: Icons.Mail,
  Maintaince: Icons.Maintaince,
  Mastercard: Icons.Mastercard,
  Medical: Icons.Medical,
  MiniCart: Icons.MiniCart,
  Minus: Icons.Minus,
  MobileMenu: Icons.MobileMenu,
  OhPrintIcon: Icons.OhPrintIcon,
  OhReturnIcon: Icons.OhReturnIcon,
  Optical: Icons.Optical,
  WeightLoss: Icons.WeightLoss,
  Ring: Icons.Ring,
  Insoles: Icons.Insoles,
  PartyHorn: Icons.PartyHorn,
  PastPurchases: Icons.PastPurchases,
  PhoneMobile: Icons.PhoneMobile,
  Phone: Icons.Phone,
  Pinch: Icons.Pinch,
  Plus: Icons.Plus,
  Quiz: Icons.Quiz,
  Remove: Icons.Remove,
  Reorder: Icons.Reorder,
  RxBottle: Icons.RxBottle,
  SadFace: Icons.SadFace,
  SearchIcon: Icons.SearchIcon,
  Search: Icons.Search,
  Secure: Icons.Secure,
  ShippingCheckMark: Icons.ShippingCheckMark,
  SignOut: Icons.SignOut,
  StarHalf: Icons.StarHalf,
  Star: Icons.Star,
  StdInfo: Icons.StdInfo,
  SummaryFooterGeneralCall: Icons.SummaryFooterGeneralCall,
  SummaryFooterGeneralChat: Icons.SummaryFooterGeneralChat,
  TooltipDanderSolid: Icons.TooltipDanderSolid,
  Tooltip: Icons.Tooltip,
  TooltipDanger: Icons.TooltipDanger,
  TrackManageOrder: Icons.TrackManageOrder,
  TrackOrder: Icons.TrackOrder,
  Twitter: Icons.Twitter,
  UpArrow: Icons.UpArrow,
  User: Icons.User,
  Visa: Icons.Visa,
  Wallet: Icons.Wallet,
  WaveLineFull: Icons.WaveLineFull,
  WaveLineHorizontal: Icons.WaveLineHorizontal,
  WaveLineVertical: Icons.WaveLineVertical,
  Youtube: Icons.Youtube,
  Zoom: Icons.Zoom,
  ChevronDown: Icons.ChevronDown,
  MinicartClose: Icons.MinicartClose,
};
